export default [{"url":"https://chilevite-0.api.invexerp.io","name":"Branch 1","port":"5043","isStore":true,"isHQ":true}]